import React from "react";

export default function ColumbusFrame4({ frameTextToggle, children }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 2000 2000"
      width="300"
      height="300"
      fill="none"
    >
      <g transform={frameTextToggle}>
        <defs>
          <style>
            {
              ".cls-4col1{fill:#dbbfaf}.cls-4col2{fill:#753c11}.cls-4col4{fill:#894b18}.cls-4col5{fill:#5e2c0b}"
            }
          </style>
        </defs>
        <path
          d="M1023.73 222.52v1017.99c0 1.86-.26 3.66-.75 5.37h-39.55c-.49-1.71-.75-3.51-.75-5.37V222.52c0-10.84 8.78-19.62 19.62-19.62h1.81c10.84 0 19.62 8.78 19.62 19.62Z"
          className="cls-4col2"
        />
        <path
          d="m1059.07 1756.73-.7 40.38h-92.42l-2.1-40.38h95.22zM1069.92 1129.2l-.91 52.79-1.11 63.89H937.34l-3.33-64.33-2.72-52.35h138.63z"
          className="cls-4col4"
        />
        <path
          d="M744.58 1372.53v116.46c-94.2 24.51-186.3 57.1-276.02 98.31-13.01-30.28-22.07-59.44-28.41-85.99 20.53-13 41.62-24.55 63.95-35.16 78.92-37.43 158.6-68.47 240.48-93.62ZM744.58 1610.16v101.48c-56.61 7.46-112.68 18.63-167.84 34.21-15.62-15.38-31.41-32.92-46.64-52.91-5.08-6.67-9.91-13.36-14.5-20.07 74.98-26.5 151.3-48.1 228.98-62.71Z"
          className="cls-4col5"
        />
        <path
          d="M744.58 1488.99v121.17c-77.68 14.61-154 36.21-228.98 62.71-19.68-28.7-35.04-57.61-47.04-85.57 89.72-41.21 181.82-73.8 276.02-98.31ZM938.99 1245.88H788.76c-24.4 0-44.18 19.78-44.18 44.19v82.46c-81.88 25.15-161.56 56.19-240.48 93.62-22.33 10.61-43.42 22.16-63.95 35.16-9.44-39.53-12.85-73.29-14.22-96.37a1043.484 1043.484 0 0 1 241.11-147.06 1043.187 1043.187 0 0 1 266.97-76.33l1.82-.27c1.05 21.53 2.1 43.07 3.16 64.6ZM965.95 1797.11h-328.2a509.619 509.619 0 0 1-61.01-51.26c55.16-15.58 111.23-26.75 167.84-34.21v.91c0 24.4 19.78 44.18 44.18 44.18h175.21l1.98 40.38Z"
          className="cls-4col2"
        />
        <path
          d="M1484.41 1672.87c-4.59 6.71-9.42 13.4-14.5 20.07-15.23 19.99-31.02 37.53-46.64 52.91-55.16-15.58-111.23-26.75-167.84-34.21v-101.48c77.68 14.61 154 36.21 228.98 62.71Z"
          className="cls-4col5"
        />
        <path
          d="M1531.45 1587.3c-12 27.96-27.36 56.87-47.04 85.57-74.98-26.5-151.3-48.1-228.98-62.71v-121.17c94.2 24.51 186.3 57.1 276.02 98.31ZM1574.07 1404.94c-1.37 23.08-4.78 56.84-14.22 96.37-20.54-13-41.62-24.55-63.95-35.16-78.92-37.43-158.6-68.47-240.48-93.62v-82.46c0-24.41-19.78-44.19-44.18-44.19h-150.23c1.06-21.53 2.11-43.07 3.16-64.6 1.6.23 3.2.47 4.83.71a1043.484 1043.484 0 0 1 505.07 222.95Z"
          className="cls-4col2"
        />
        <path
          d="M1559.85 1501.31c-6.34 26.55-15.4 55.71-28.41 85.99-89.72-41.21-181.82-73.8-276.02-98.31v-116.46c81.88 25.15 161.56 56.19 240.48 93.62 22.33 10.61 43.41 22.16 63.95 35.16Z"
          className="cls-4col5"
        />
        <path
          d="M1423.27 1745.85a509.619 509.619 0 0 1-61.01 51.26h-328.2l1.98-40.38h175.21c24.4 0 44.18-19.78 44.18-44.18v-.91c56.61 7.46 112.68 18.63 167.84 34.21Z"
          className="cls-4col2"
        />
        <rect
          width={735.32}
          height={38.81}
          x={634.62}
          y={405.11}
          className="cls-4col2"
          rx={19.4}
          ry={19.4}
        />
        <rect
          width={1139.74}
          height={38.81}
          x={430.13}
          y={864.44}
          className="cls-4col2"
          rx={19.4}
          ry={19.4}
        />
        <path
          d="M694.52 443.92A1390.737 1390.737 0 0 0 571.3 629.79a1390.589 1390.589 0 0 0-102.75 234.65c111.22-44.26 299.94-103.29 539.86-101.89 231.14 1.35 413.35 58.24 523.04 101.89-14.91-65.29-41.77-151.5-92.39-244.49-40.38-74.16-84.91-132.49-123.41-176.04a4723.359 4723.359 0 0 1-317.44 10.21c-106.81-.16-208.22-3.93-303.67-10.21Z"
          style={{
            fill: "#e8d0c1",
          }}
        />
        <path
          d="M1533.74 864.44c-109.69-43.65-291.9-100.53-523.04-101.88-239.92-1.41-428.64 57.63-539.86 101.88a1390.589 1390.589 0 0 1 102.75-234.65 1390.737 1390.737 0 0 1 123.22-185.87l11.14.72a1469.069 1469.069 0 0 0-48.65 97.44c-39.02 85.9-65.78 166.34-84.42 234.65 91.37-44.25 246.41-103.29 443.51-101.88 189.89 1.35 339.57 58.23 429.68 101.88-12.25-65.29-34.31-151.5-75.9-244.48-8.98-20.08-18.21-38.99-27.52-56.77a954.541 954.541 0 0 1 96.69 144.48c50.63 92.98 77.48 179.19 92.4 244.48ZM1235.13 293.08c-28.79 12.79-53.56 16.72-72.6 17.44-30.13 1.15-43.82-5.78-71.31-3.15-28.2 2.7-50.91 13.54-67.5 24.2v-90.19c9.8-6.38 25.23-14.87 45.85-19.8 33.89-8.11 54.38-.06 91.69-2.2 17.86-1.02 43.36-4.6 73.86-16.5v90.19Z"
          className="cls-4col1"
        />
        {children}
      </g>
    </svg>
  );
}
